import { computed } from 'mobx';
import { ContainerableBlock } from '~/models/blocks/containerable-block.model';
import { IChargeContainerBlockResponse } from '~/types/server.types';
import type { ChargeBlock } from '~/models/blocks/charge-block.model';
import { TBlock } from '~/types/builder.types';
import type { FlowRevision } from '~/models/flow-revision.model';
import type { RootStore } from '~/stores/root.store';

type ChargeContainerBlockDataForServer = ReturnType<
    ContainerableBlock['getDataForServer']
> &
    Pick<IChargeContainerBlockResponse, 'type'>;

export class ChargeContainerBlock extends ContainerableBlock {
    type: 'charge_container_block';

    constructor(
        block: IChargeContainerBlockResponse,
        flowRevision: FlowRevision<RootStore>,
        rootStore: RootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    get isPrintable() {
        return false;
    }

    get isDeletable() {
        return true;
    }

    @computed
    get chargeBlock() {
        return this.childBlocks.find(
            block => block.type === 'charge_block'
        ) as ChargeBlock;
    }

    get isActionBlock() {
        return true;
    }

    get isResponsesActionBlock() {
        return true;
    }

    isDraggable() {
        return false;
    }

    dndAcceptedTypes() {
        return null;
    }

    get displayName() {
        return 'online payment';
    }

    @computed
    override get coupledBlocks(): TBlock[] {
        return [this.flow.invoiceContainerBlock];
    }

    canBeParentOf(block: TBlock) {
        return block.type === 'charge_block';
    }

    getDataForServer(): ChargeContainerBlockDataForServer {
        return {
            ...super.getDataForServer(),
            type: this.type as 'charge_container_block'
        };
    }
}
